import { render, staticRenderFns } from "./PreOptionalQuestion.vue?vue&type=template&id=508647e4&scoped=true&"
import script from "./PreOptionalQuestion.vue?vue&type=script&lang=js&"
export * from "./PreOptionalQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PreOptionalQuestion.vue?vue&type=style&index=0&id=508647e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508647e4",
  null
  
)

export default component.exports